// SavedTeam.js
import React, { useState, useEffect } from "react";
import "./savedteam.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import NavbarSidebarWrapper from "../../navbarSidebarWrapper";
import { getSelectedMatch, getSelectedTeamPlayers } from "../../../utils/playerSession";

function SavedTeam() {
  const navigate = useNavigate();
  const { id: teamId } = useParams();
    const location = useLocation();
    const teamDetails = location.state?.team;

  const [team, setTeam] = useState(null);
  const [matchDetails, setMatchDetails] = useState(null);
  const [stats, setStats] = useState(null);
  const [players, setPlayers] = useState({
    wicketKeepers: [],
    batters: [],
    allRounders: [],
    bowlers: [],
  });

  useEffect(() => {
    loadTeam();
  }, [teamId]);

  const loadTeam = () => {
    const foundTeam = getSelectedTeamPlayers() || "[]";
    const foundMatch = getSelectedMatch() || "[]";

    if (foundTeam) {
      const totalPlayers = foundTeam.length;
      // Credits Used
      const creditsUsed = foundTeam.reduce(
        (sum, player) => sum + Number(player.credit || 0),
        0
      );
      // Team Count (Home & Away)
      const teamANum = foundTeam.filter(
        (player) => player.country === foundMatch?.away?.name
      ).length;

      const teamBNum = foundTeam.filter(
        (player) => player.country === foundMatch?.home?.name
      ).length;
      const stats = {
        totalPlayers,
        teamANum,
        teamBNum,
        creditsUsed,
      };
      setStats(stats);
      setTeam(foundTeam);
      setMatchDetails(foundMatch);

      const grouped = {
        wicketKeepers: [],
        batters: [],
        allRounders: [],
        bowlers: [],
      };

      foundTeam.forEach((player) => {
        const role = player.role?.toLowerCase() || "";

        if (role.includes("wk")) {
          grouped.wicketKeepers.push(player);
        }
        else if (role.includes("allrounder")) {
          grouped.allRounders.push(player);
        }
        else if (role.includes("bowler")) {
          grouped.bowlers.push(player);
        }
        else if (role.includes("batter")) {
          grouped.batters.push(player);
        }
      });

      setPlayers(grouped);
    }
  };

  const getShortName = (name) => {
    const parts = name.split(" ");
    return parts.length > 1 ? parts[1] : parts[0];
  };

  const renderCategory = (title, list, cols) => (
    <div className="mb-4">
      <h3 className="heading text-uppercase">{title}</h3>
      <div className="row text-center">
        {list.map((p) => (
          <div key={p.id} className={`col-${cols} mb-3`}>
            <div className="player-wrapper">
              <img
                src={`https://cdn0.iconfinder.com/data/icons/cricket-22/512/Cricket_Player.png`}
                alt={p.name}
                className="player-img"
              />
              {Number(p.id) === Number(teamDetails?.CaptainId)  && (
                <span
                  className="badge bg-success"
                  style={{ top: -10, right: 10 }}
                >
                  C
                </span>
              )}
              {Number(p.id) === Number(teamDetails?.ViceCaptainId)   && (
                <span
                  className="badge bg-warning "
                  style={{ top: -10, right: 10 }}
                >
                  VC
                </span>
              )}
              
              <div
                className={
                  p.code === matchDetails?.teamHomeCode
                    ? "title"
                    : "away-title"
                }
              >
                {getShortName(p.name)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  if (!team) {
    return (
      <div className="saved-team-container text-center py-5">
        <p className="text-white">Team not found</p>
        <button className="btn btn-primary mt-3" onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
    );
  }

  return (
    <NavbarSidebarWrapper>
      <div className="content-wrapper me-0 mb-4">
        <div className="saved-team-container">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-4 p-3 bg-dark text-white">
            <div>
              <h4 className="mb-0">
                {matchDetails?.away?.code} vs{" "}
                {matchDetails?.home?.code}
              </h4>
              <small className="text-white">
                Created: {new Date(matchDetails?.date).toLocaleDateString()}
              </small>
            </div>
            <div>
              <button
                className="btn btn-sm btn-warning me-2"
                onClick={() =>
                  navigate(`/createteam/${matchDetails.matchId}?edit=${teamId}`)
                }
              >
                Edit Team
              </button>
              <button className="btn btn-sm btn-light" onClick={() => navigate(-1)}>
                ✖
              </button>
            </div>
          </div>

          {/* Team Stats */}
          <div className="row text-center mb-4 bg-light p-3 text-muted">
            <div className="col">
              <p className="mb-0 small">Players</p>
              <strong>{stats?.totalPlayers || 11}</strong>
            </div>
            <div className="col">
              <p className="mb-0 small">{matchDetails?.home.code}</p>
              <strong>{stats?.teamANum}</strong>
            </div>
            <div className="col">
              <p className="mb-0 small">{matchDetails?.away.code}</p>
              <strong>{stats?.teamBNum}</strong>
            </div>
            <div className="col">
              <p className="mb-0 small">Credits Used</p>
              <strong>{stats?.creditsUsed?.toFixed(1)}</strong>
            </div>
          </div>

          {/* Render categories */}
          {renderCategory("Wicket Keepers", players.wicketKeepers, 6)}
          {renderCategory("Batters", players.batters, 3)}
          {renderCategory("All Rounders", players.allRounders, 6)}
          {renderCategory("Bowlers", players.bowlers, 4)}
        </div>
      </div>
    </NavbarSidebarWrapper>
  );
}

export default SavedTeam;
